import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';
import { Col, Row, Separator, Text } from '@cuemath/comps';
import Link from 'comps/link';

const HeaderRow = styled(Row)`
  border-bottom: 1px solid ${({ theme: { COLORS } }) => COLORS.BORDER};
`;
const TabCol = styled(Col)`
  position: relative;
  min-width: 120px;

  ${({ selected, theme: { COLORS } }) =>
    selected &&
    css`
      &:after {
        position: absolute;
        content: '';
        left: 0;
        bottom: -3px;
        height: 3px;
        width: 100%;
        background: ${COLORS.PRIMARY};
      }
    `};
`;
const TabText = styled(Text)`
  line-height: 40px;
`;

function Tabs({ tabs, activeTab, ...other }) {
  const tab = activeTab ? tabs.find(({ id }) => id === activeTab) : null;
  const { Component, id: activeTabId } = tab || tabs[0];

  return (
    <Fragment>
      <HeaderRow nowrap>
        {tabs.map(({ id, label, link }) => (
          <TabCol selected={id === activeTabId} key={id - { label }}>
            <Link to={link}>
              <TabText
                weight={id === activeTabId ? 'bold' : 'normal'}
                type={id === activeTabId ? 'primary' : 'normal'}
                align="center"
              >
                {label}
              </TabText>
            </Link>
          </TabCol>
        ))}
      </HeaderRow>
      <Separator height={40} transparent />
      <Component {...other} />
    </Fragment>
  );
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      Component: PropTypes.any.isRequired,
    }),
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
};

export default memo(Tabs);
